import React from "react";
import Footer from "./footer";
import SectionTitle from "./section-title";
import Leaders from "./leaders";
import Promise from "./promise";
import Uniform from "./uniform";

function Squirrels() {
  return (
    <div className="squirrels" id="squirrels">
      <SectionTitle section={"squirrels"} />
      <Leaders section={"squirrels"} />
      <Promise
        section={"squirrels"}
      />
      <Uniform 
        section={"squirrels"}
      />
      <Footer />
    </div>
  );
}

export default Squirrels;
